import React, { useState, useEffect } from "react";
import TeacherAdmin from "../../components/Teacher/Tabs/TeacherAdmin";
import TeacherResultOverview from "../../components/Teacher/Tabs/TeacherResultOverview";
import TeacherDocuments from "../../components/Teacher/Tabs/TeacherDocuments";
import TeacherCourses from "../../components/Teacher/Tabs/TeacherCourses";
import TeacherChat from "../../components/Teacher/Tabs/TeacherChat";
import { CCard, CRow, CCol, CCardBody } from "@coreui/react";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import {
  GetProgramById,
  GetTeacherInformation,
  GetSchoolDataBySchoolId,
} from "../../actions/teacherQueries";
import TabNavSelector from "../../components/Teacher/Tabs/TabNavSelector";
import APL from "../../components/APL/APL";
import { useSelector } from "react-redux";

export default function TeacherProgram(props) {
  const [studentsInProgram, setStudentsInProgram] = useState([]);
  const programInfo = GetProgramById(props.match.params.programId);
  const teacherInfo = GetTeacherInformation();

  const customerId = teacherInfo?.data?.customer?.id ?? null;
  const schoolInfo = GetSchoolDataBySchoolId(customerId);

  const tab = useSelector((state) => state.teacherTabNavReducer);

  useEffect(() => {
    if (!teacherInfo.isLoading && teacherInfo.data) {
      const currentProgram = teacherInfo.data.programmes.find(
        (program) => program.id === Number(props.match.params.programId)
      );
      if (!currentProgram) {
        props.history.push("/teacher");
        return;
      }
      const tempStudentsInProgram = [];
      currentProgram.classes.forEach((cl) => {
        tempStudentsInProgram.push(...cl.students);
      });
      setStudentsInProgram(tempStudentsInProgram);
    }
  }, [props.match.params.programId, props.history, teacherInfo.data, teacherInfo.isLoading]);

  if (programInfo.isLoading || teacherInfo.isLoading || schoolInfo.isLoading) {
    return <Pacmanloader />;
  }

  const renderTab = () => {
    switch (tab.tab) {
      case 1:
        return (
          <TeacherAdmin
            level="Program"
            programInfo={programInfo}
            teacherInfo={teacherInfo}
            schoolInfo={schoolInfo}
          />
        );
      case 2:
        return (
          <TeacherCourses
            programId={Number(props.match.params.programId)}
            teacherInfo={teacherInfo}
            objId={"program" + props.match.params.programId}
            displayDocuments={false}
            level="Program"
          />
        );
      case 3:
        return (
          <TeacherResultOverview
            level="Program"
            programId={Number(props.match.params.programId)}
          />
        );
      case 5:
        return <TeacherDocuments level="Program" />;
      case 6:
        return <TeacherChat level="Program" />;
      case 7:
        return (
          <APL
            level="Program"
            students={studentsInProgram}
            levelName={programInfo.data.name}
            objId={programInfo.data.id}
            schoolId={teacherInfo.data.customer.id}
            programId={props.match.params.programId}
            teacherInfo={teacherInfo}
          />
        );
      default:
        return <TeacherAdmin level="Program" />;
    }
  };
  return (
    <div className="teacher-container animated fadeIn">
      <CRow>
        <CCol lg={12}>
          <CCard>
            <TabNavSelector level="program" objId={props.match.params.programId} />
            <CCardBody className="responsive-card">{renderTab()}</CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
}
